import gql from 'graphql-tag'

export default gql`
  mutation upsertOutstandingLoan($input: UpsertOutstandingLoanInput!) {
    upsertOutstandingLoan(input: $input) {
      outstandingLoan {
        rid
        monthsRemaining
        monthlyPayment
        principalBalance
        originationDate
        debtType
        lender
        refinance
        minimumPayment
        paymentFrequency
      }
    }
  }
`
